import Loading from '../../../Common/Loading';
import { DeterminedNatureAnualList } from './DeterminedNatureAnual';
import { DeterminedNatureMonthList } from './DeterminedNatureMonth';
import { useCrimesChartsDataContext } from './hooks/useCrimesChartsDataContext';
import React, { memo } from 'react';

const NatureTab = memo(() => (
    <div className="charts-side-by-side-dashboards">
        <DeterminedNatureAnualList />
        <DeterminedNatureMonthList />
    </div>
));

export const Charts = () => {
    const { isLoading } = useCrimesChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <NatureTab />
    );
};
